import "./App.css";
import AllRoutes from "./AllRoutes";
import { useTheme } from "@mui/material";

function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
